import Vue from 'www/vue_components'
import I18NextVue from 'i18next-vue'
import { initI18n } from 'www/utils'
import vuetify from 'www/modules/vuetify-plugin'
import DoctorFilterPanel from 'www/vue_components/common/DoctorFilterPanel/DoctorFilterPanel.vue'

async function mountDoctorFiltersPanel() {
  const mountElement = document.querySelector('.vue-mount-doctor-filter-panel')

  const { i18next } = await initI18n({ bundle: 'vue_components/common/DoctorFilterPanel' })

  Vue.use(I18NextVue, { i18next })

  if (mountElement) {
    new Vue({
      el: mountElement,
      vuetify,
      components: {
        DoctorFilterPanel,
      },
    })
  }
}

mountDoctorFiltersPanel()
